import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_CLEAR_RELAUNCH_ENFORCEMENT,
  LINKS_MANAGEMENT_RELAUNCH_ENFORCEMENT,
} from '../../../../actions/actionTypes';

const relaunchEnforcement = fetchReducerGenerator(
  [LINKS_MANAGEMENT_CLEAR, LINKS_MANAGEMENT_CLEAR_RELAUNCH_ENFORCEMENT],
  LINKS_MANAGEMENT_RELAUNCH_ENFORCEMENT
);

const RELAUNCH_ENFORCEMENT_STATUSES = Object.freeze({
  success: 'success',
  error: 'error',
});

export const getLinksManagementRelaunchEnforcementSuccessfulLinksCount = ({
  response,
  error,
}) => {
  const allLinksEnforcedSuccessfullyCount =
    response?.status === HttpStatus.OK.value &&
    getNumberOfEnforcedLinks(
      response.data,
      RELAUNCH_ENFORCEMENT_STATUSES.success
    );

  const someLinksEnforcedSuccessfullyCount =
    error?.status === HttpStatus.CALL_FAILURE.value &&
    getNumberOfEnforcedLinks(error.data, RELAUNCH_ENFORCEMENT_STATUSES.success);

  if (
    !allLinksEnforcedSuccessfullyCount &&
    !someLinksEnforcedSuccessfullyCount
  ) {
    return null;
  }

  return (
    allLinksEnforcedSuccessfullyCount || someLinksEnforcedSuccessfullyCount
  );
};

export const getLinksManagementRelaunchEnforcementErrorLinksCount = ({
  error,
}) =>
  getNumberOfEnforcedLinks(error?.data, RELAUNCH_ENFORCEMENT_STATUSES.error);

export const getLinksManagementRelaunchEnforcementErrors = ({ error }) => {
  if (error?.status !== HttpStatus.CALL_FAILURE.value) {
    return null;
  }

  const result = error.data.reduce((result, linkError) => {
    const { key, value } = linkError;
    const [linkType, linkUrl] = getKeys(key);
    if (!result[linkType]) {
      result[linkType] = {};
    }

    value.response = linkUrl;
    result[linkType][linkUrl] = value;

    return result;
  }, {});

  return result;
};

const getKeys = key => {
  const index = key.indexOf('_');
  return [key.slice(0, index), key.slice(index + 1)];
};

const getNumberOfEnforcedLinksForTargetLinkType = (
  targetLinkType,
  enforcementResponseArray,
  status
) =>
  enforcementResponseArray.filter(linkData => {
    const [linkType] = getKeys(linkData.key);
    const isSuccessfulEnforcement =
      status === RELAUNCH_ENFORCEMENT_STATUSES.success;

    return (
      targetLinkType === linkType &&
      (isSuccessfulEnforcement
        ? linkData.value.status === HttpStatus.NO_CONTENT.value
        : linkData.value.status !== HttpStatus.NO_CONTENT.value)
    );
  }).length;

const getNumberOfEnforcedLinks = (enforcementResponseArray = [], status) => {
  const numberOfDetectionLinks = getNumberOfEnforcedLinksForTargetLinkType(
    LinkTypeEnum.DETECTION.name,
    enforcementResponseArray,
    status
  );
  const numberOfContentLinks = getNumberOfEnforcedLinksForTargetLinkType(
    LinkTypeEnum.CONTENT.name,
    enforcementResponseArray,
    status
  );

  if (!numberOfDetectionLinks && !numberOfContentLinks) {
    return null;
  }

  return {
    [LinkTypeEnum.DETECTION.name]: numberOfDetectionLinks,
    [LinkTypeEnum.CONTENT.name]: numberOfContentLinks,
  };
};

export default relaunchEnforcement;
